if (!Object.entries)
  Object.entries = function(obj) {
    return Object.keys(obj).reduce(function(arr, key) {
      arr.push([key, obj[key]]);
      return arr;
    }, []);
  }



// WEBPACK FOOTER //
// ./polyfills.js